import React from 'react';

import contents from 'app/api/contents';
import Paragraph from 'app/components/BookElements/Paragraph';

export default class LayoutEngine {
  constructor(elements = {}) {
    // elements = object indexed by element type
    this.elements = {
      paragraph: Paragraph,
      ...elements,
    };
  }
  render({ type, path }) {
    let content = contents.get(path);
    let Element = this.elements[type];
    if (!Element) return null;
    return <Element key={path} {...this.props} path={path} content={content} />;
  }
}



// WEBPACK FOOTER //
// ./src/app/api/layoutEngine.js